module.exports = __webpack_public_path__ + "static/media/energysmart-promo.2a38e24a.webp";